export const NAME = 'FlightAlertHistory';
export const DAY = 'day';
export const MONTH = 'month';
export const BLUEPARTOFGRAPH = 'alertsSent';
export const YELLOWPARTOFGRAPH = 'bounced';
export const REDPARTOFGRAPH = 'issuesIdentified';



// WEBPACK FOOTER //
// ./modules/FlightAlerts/redux/Historical/constants.js